export default __webpack_public_path__ + "static/media/donationImage.68c7b08b.svg";